import { resolveLocalizedText } from '@seaa/shared/localized-text'
import { type AvailabilitySlot, type Locale } from '@seaa/shared'

/** Language changes affect display only; the held price and time remain fixed. */
export function localizeHeldSlot(slot: AvailabilitySlot, locale: Locale): AvailabilitySlot {
  return {
    ...slot,
    resourceName: resolveLocalizedText(slot.resourceNameLocales, locale, slot.resourceNameOriginal ?? slot.resourceName),
    serviceName: resolveLocalizedText(slot.serviceNameLocales, locale, slot.serviceNameOriginal ?? slot.serviceName ?? null),
  }
}
